(function(){

    function ResponsiveTooltip() {
        this.tooltipsArray = null;
        document.addEventListener('DOMContentLoaded', this.init.bind(this));
    }

    ResponsiveTooltip.prototype.init = function() {
        this.tooltipsArray = Array.from(document.querySelectorAll('.js-responsive-tooltip'));
        var resizeObserver = new ResizeObserver(this.resizeCallback.bind(this));
        resizeObserver.observe(document.body);
    };

    ResponsiveTooltip.prototype.resizeCallback = function() {
        for (var i = 0; i < this.tooltipsArray.length; ++i) {
            this.positionTooltip(this.tooltipsArray[i]);
        }
    };

    /**
     * Positions a tooltip
     * 
     * @param {HTMLElement} tooltip
     */
    ResponsiveTooltip.prototype.positionTooltip = function(tooltip) {
        var hPadding = 10;
        var parentRect = tooltip.closest('button').getBoundingClientRect();
        var arrow = tooltip.querySelector('.tooltip-arrow');
        var arrowRect = arrow.getBoundingClientRect();
        var tooltipRect = tooltip.getBoundingClientRect();

        var iconX = parentRect.x + parentRect.width/2;
        var potentialTooltipX = iconX - tooltipRect.width/2;

        if (potentialTooltipX < hPadding) {
            arrow.style.right = 'auto';
            tooltip.style.right = 'auto';
            tooltip.style.transform = 'none';
            arrow.style.transform = 'none';

            var hOffset = parentRect.x*-1 + hPadding;
            tooltip.style.left = hOffset + 'px';
            var arrowX = Math.abs(hOffset) + arrowRect.width/2;
            arrow.style.left = arrowX + 'px';
        }
        else if ((potentialTooltipX + tooltipRect.width) > (window.innerWidth - hPadding)) {
            tooltip.style.left = 'auto';
            arrow.style.left = 'auto';
            tooltip.style.transform = 'none';
            arrow.style.transform = 'none';

            var hOffset = window.innerWidth - (parentRect.x + parentRect.width + hPadding);
            tooltip.style.right = hOffset*-1 + 'px';
            var arrowX = Math.abs(hOffset) + arrowRect.width/2;
            arrow.style.right = arrowX + 'px';
        }
        else {
            arrow.style.removeProperty('left');
            tooltip.style.removeProperty('left');
            arrow.style.removeProperty('right');
            tooltip.style.removeProperty('right');
            arrow.style.removeProperty('transform');
            tooltip.style.removeProperty('transform');
        }
    };

    function ClickedTooltip() {
        this.tooltipsArray = null;
        document.addEventListener('DOMContentLoaded', this.init.bind(this));
    }

    ClickedTooltip.prototype.init = function() {
        this.tooltipsArray = Array.from(document.querySelectorAll('.tooltips-botones'));
        for (var i = 0; i < this.tooltipsArray.length; ++i) {
            this.tooltipsArray[i].addEventListener('mouseenter', this.handleMouseEnter.bind(this));
        }

        window.addEventListener('click', this.handleWindowClick.bind(this));
    };

    /**
     * Closes all tooltips except the one passed as parameter
     * 
     * @param {HTMLElement} exception
     */
    ClickedTooltip.prototype.closeAll = function(exception) {
        for (var i = 0; i < this.tooltipsArray.length; ++i) {
            if (this.tooltipsArray[i] !== exception) {
                this.tooltipsArray[i].classList.remove('visible');
            }
        }
    };

    /**
     * Handles a click in the Window. All tooltips should be closed, except the clicked one, if any.
     * 
     * @param {Event} event
     */
    ClickedTooltip.prototype.handleWindowClick = function(event) {
        var clickedTooltip = event.target.closest('.js-clicked-tooltip');

        this.closeAll(clickedTooltip);

        if (clickedTooltip) {
            clickedTooltip.classList.toggle('visible');
        }
    };

    /**
     * Handles the event when the mouse enters a tooltip button
     * 
     * @param {Event} event
     */
    ClickedTooltip.prototype.handleMouseEnter = function(event) {
        var clickedTooltip = event.target.closest('.js-clicked-tooltip');
        this.closeAll(clickedTooltip);
    };

    new ClickedTooltip();
    new ResponsiveTooltip();
})();
